import React from "react";

const style = {
	layoutWrapper: `bg-dark min-h-screen p-6 lg:px-[10vw] overflow-x-hidden`,
};

const Layout = ({ children }) => {
	return <div className={style.layoutWrapper}>{children}</div>;
};

export default Layout;
